module.exports = __webpack_public_path__ + "static/media/login-logo.1ce334b2.png";